import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/** Resolve a relative `/api/...` URL returned by the backend (e.g. file
 * downloads) into an absolute URL the browser can fetch directly. */
export const resolveFileUrl = (path) => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  if (path.startsWith("/api/")) return `${BACKEND_URL}${path}`;
  return path;
};

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Attach Authorization header from localStorage as fallback (cookies are primary)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("access_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Defensive: if a reverse-proxy is misconfigured and returns HTML for an /api/*
// path (instead of JSON), turn it into a friendly error so the React app does
// not crash with `.slice(...).map is not a function`-type errors.
api.interceptors.response.use(
  (resp) => {
    const ct = (resp.headers?.["content-type"] || "").toLowerCase();
    if (typeof resp.data === "string" && resp.data.startsWith("<!doctype")) {
      // eslint-disable-next-line no-console
      console.error(
        "[api] Got HTML for an /api/* request — reverse proxy likely misrouting. URL:",
        resp.config?.url,
      );
      return Promise.reject(
        Object.assign(new Error("API proxy misconfigured (received HTML)"), {
          response: { status: 502, data: { detail: "Bad gateway (API proxy)" } },
        }),
      );
    }
    // Some endpoints are documented as returning an array; if a non-array sneaks
    // through, callers can fall back themselves — we don't mutate the body here.
    return resp;
  },
  (err) => Promise.reject(err),
);

export function formatApiError(detail) {
  if (detail == null) return "حدث خطأ. حاول مجدداً.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" • ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function hijriString(date = new Date()) {
  try {
    return new Intl.DateTimeFormat("ar-SA-u-ca-islamic", {
      day: "numeric", month: "long", year: "numeric",
    }).format(date);
  } catch {
    return "";
  }
}

export function gregorianString(date = new Date(), locale = "ar-SA") {
  return new Intl.DateTimeFormat(locale, {
    day: "numeric", month: "long", year: "numeric",
  }).format(date);
}
